// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2fc3ce00","498":"da28a5d7","703":"322b6698"}[chunkId] + ".chunk.js";
};